import Button from "@gfg/ui-v2/components/button";
import { makeStyles } from "@gfg/ui-v2/theming";

const useStyles = makeStyles()(({ spacing }) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: spacing(32),
  },
  buttonsContainer: {
    "& > button": {
      marginLeft: spacing(12),
    },
  },
}));

interface SearchOptimizationsFormHeaderProps {
  disabledSubmit: boolean;
  title: string;
  onCancel(): void;
}

export default function SearchOptimizationsFormHeader({
  disabledSubmit,
  title,
  onCancel,
}: SearchOptimizationsFormHeaderProps) {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <h3>{title}</h3>
      <div className={classes.buttonsContainer}>
        <Button variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button disabled={disabledSubmit}>Save</Button>
      </div>
    </div>
  );
}
